import Module, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import LoadingView from "./loading_view";
import VersionManager from "../../../../manager/version_manager";
import { GameManager } from '../../../../manager/game_manager';
import LanguageManager from "../../../../manager/language_manager";
import ModuleManager from "../../../../framework/core/module_manager";

import AppData from "../../const/app_data";
import Dialog from "../dialog/dialog";


const {ccclass} = cc._decorator;

@ccclass
@moduleInit("LoadingModule")
export default class LoadingModule extends Module<LoadingView,null> {

    private inited = false ;

    constructor() {
        super();
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/public_loading";
        this.viewType = LoadingView;
        this.modelType = null;
    }

    bindEvent(){
        this.eventBind("already_up_to_date",this.already_up_to_date);        
        this.eventBind("new_version_found",this.on_new_version_found);
        this.eventBind("update_progress",this.on_update_progress);
        this.eventBind("update_finished",this.on_update_finished);
        //错误处理都可以用同一个
        this.eventBind("update_failed",this.on_update_failed);
        this.eventBind("error_download_manifest_file",this.on_update_failed);
        // this.eventBind("asset update error",this.on_update_failed);
        this.eventBind("error_decompress",this.on_update_failed);
    }

    onShow(content : any) {

        // if (content) {
            
        //     if (content.progress) {
             
        //         this.updatePercent(content.progress);
        //     }            

        //     if (content.text) {
                
        //         this.view.showTextLabel(content.text);
        //     }

        // }

        if (!this.inited) {
            this.bindEvent();
            GameManager.hideAndroidSplash()
        }
        this.inited = true

        if (content) {
            let value = 0
            let self = this
            this.schedule(() => {
                value += 0.01
                self.updatePercent(value)
            }, 0.01, 100)
        }
    }


    already_up_to_date(){
        this.view.showTextLabel(LanguageManager.t("public_update_already_up_to_date", true));
    }

    on_new_version_found(){
        this.view.showTextLabel(LanguageManager.t("public_update_new_version", true))
    }

    on_update_progress(data){
        data = isNaN(data) ? 0 : data
        this.updatePercent(data)

        this.view.showTextLabel(LanguageManager.t("public_loadingRes", true) + ":" +(data * 100).toFixed(2) + "%");
    }

    on_update_finished(){
        this.view.showTextLabel(LanguageManager.t("public_update_update_finish", true))
    }

    on_update_failed(msg : string){
        let self = this
        ModuleManager.instance.showModule<Dialog>(Dialog).show_center_button(null, LanguageManager.t("public_update_error", true), () => {
            if (msg == "GetVersionDataError" || msg == "error_download_manifest_file") {
                GameManager.getVersionConfigData((needUpdate, error) => {
                    if (error) {
                        self.on_update_failed("GetVersionDataError")
                    }
                })
            } else {
                this.view.showTextLabel(msg);
                VersionManager.instance.retry();
            }
        });
    }

    updatePercent(percent : number){
        this.view.updatePercent(percent);
    }

}
